import { ConfigTopNode } from '@/types'
import Utils from '@/lib/utils'

export default {
  parseMapToJSON(
    topLevelModuleNameToChildrenIDsMap: Object,
    configNodesMap: Object,
    rootNodeIds: Object
  ): string {
    let savedFileContentObject: Object = {
      configuration: {
        seqs: {},
        paths: {},
        mods: {},
        psets: {},
        tasks: {},
        esprods: {},
        essources: {},
        services: {},
      },
    }
    let sequencesObject: Object = {}
    let pathsObject: Object = {}
    let modulesObject: Object = {}
    let psetsObject: Object = {}
    let tasksObject: Object = {}
    let esProducersObject: Object = {}
    let esSourcesObject: Object = {}
    let servicesObject: Object = {}
    //parse the map here
    for (const [nodeId, nodeObject] of Object.entries(
      rootNodeIds as Map<string, Object>
    )) {
      /*      console.log('OUTER KEY: ' + nodeId)
      console.log('VALUE ID: ' + value.id) */
      if (
        configNodesMap[nodeId].type == 'sequences' &&
        rootNodeIds['sequences'] == nodeId //main sequence node
      ) {
        sequencesObject[configNodesMap[nodeId].name] = []
        //now go through all sequence children and add them to array
        for (const [key1, value1] of Object.entries(
          configNodesMap[nodeId].children
        )) {
          let childrenObject = Array()
          childrenObject.push(configNodesMap[nodeId].children[key1].type)
          childrenObject.push(configNodesMap[nodeId].children[key1].name)
          sequencesObject[configNodesMap[nodeId].name].push(childrenObject)
        }
      } else if (
        configNodesMap[nodeId].type == 'paths' &&
        rootNodeIds[configNodesMap[nodeId].name] == nodeId //main path node
      ) {
        pathsObject[configNodesMap[nodeId].name] = []
        //now go through all path children and add them to array
        for (const [key1, value1] of Object.entries(
          configNodesMap[nodeId].children
        )) {
          let childrenObject = Array()
          childrenObject.push(configNodesMap[nodeId].children[key1].type)
          childrenObject.push(configNodesMap[nodeId].children[key1].name)
          pathsObject[configNodesMap[nodeId].name].push(childrenObject)
        }
      } else if (
        configNodesMap[nodeId].type == 'modules' &&
        rootNodeIds[configNodesMap[nodeId].name] == nodeId //main module node
      ) {
        let moduleObject: Object = { params: {}, ctype: '', pytype: '' }

        //now go through all module childrenIds and add children to array
        let childrenIdsArray = Array.from(
          topLevelModuleNameToChildrenIDsMap[configNodesMap[nodeId].name]
        ) as Array<number>
        for (let i = 0; i < childrenIdsArray.length; i++) {
          let paramObject: Object = {}
          paramObject['type'] = configNodesMap[childrenIdsArray[i]].type
          if (
            paramObject['type'] == 'cms.VPSet' ||
            paramObject['type'] == 'cms.PSet' ||
            paramObject['type'] == 'cms.untracked.PSet' ||
            paramObject['type'] == 'cms.untracked.VPSet'
          ) {
            //parse children here recursivly to elementary parameter objects
            this.parseRecursiveVPSetObject(
              paramObject,
              configNodesMap[childrenIdsArray[i]].children
            )
            moduleObject['params'][
              configNodesMap[childrenIdsArray[i]].name
            ] = paramObject
          } else {
            paramObject['value'] =
              configNodesMap[childrenIdsArray[i]].paremeterJSONValue

            moduleObject['params'][
              configNodesMap[childrenIdsArray[i]].name.substring(
                0,
                configNodesMap[childrenIdsArray[i]].name.length - 3
              )
            ] = paramObject

            /*    if (nodeId == '28733')
              console.log(
                'PARAMSSSSSS 28733: ' +
                  JSON.stringify(
                    moduleObject['params'][
                      configNodesMap[nodeId].children[
                        key1
                      ].name.substring(
                        0,
                        configNodesMap[nodeId].children[key1].name
                          .length - 3
                      )
                    ]
                  )
              ) */
          }
        }
        moduleObject['ctype'] = configNodesMap[nodeId].ctype
        moduleObject['pytype'] = configNodesMap[nodeId].pytype
        modulesObject[configNodesMap[nodeId].name] = moduleObject
        /*      if (configNodesMap[nodeId].name == 'siPixelClusters_clone') {
          console.log('CLONE NAME: ' + configNodesMap[nodeId].name)
          console.log(
            'CLONEEEEE: ' +
              JSON.stringify(modulesObject[configNodesMap[nodeId].name])
          )
        } */
      } else if (
        configNodesMap[nodeId].type == 'pset' &&
        rootNodeIds[configNodesMap[nodeId].name] == nodeId //main pset node
      ) {
        let psetObject: Object = {}
        //now go through all pset children and add them to array
        for (const [key1, value1] of Object.entries(
          configNodesMap[nodeId].children
        )) {
          let paramObject: Object = {}
          paramObject['type'] = configNodesMap[nodeId].children[key1].type
          if (
            paramObject['type'] == 'cms.VPSet' ||
            paramObject['type'] == 'cms.PSet' ||
            paramObject['type'] == 'cms.untracked.PSet' ||
            paramObject['type'] == 'cms.untracked.VPSet'
          ) {
            //parse children here recursivly to elementary parameter objects
            this.parseRecursiveVPSetObject(
              paramObject,
              configNodesMap[nodeId].children[key1].children
            )
            psetObject[configNodesMap[nodeId].children[key1].name] = paramObject
          } else {
            paramObject['value'] =
              configNodesMap[nodeId].children[key1].paremeterJSONValue

            psetObject[configNodesMap[nodeId].children[key1].name] = paramObject
          }
        }
        psetsObject[configNodesMap[nodeId].name] = psetObject
      } else if (
        configNodesMap[nodeId].type == 'tasks' &&
        rootNodeIds[configNodesMap[nodeId].name] == nodeId //main task node
      ) {
        tasksObject[configNodesMap[nodeId].name] = []
        //now go through all task children and add them to array
        for (const [key1, value1] of Object.entries(
          configNodesMap[nodeId].children
        )) {
          let childrenObject = Array()
          childrenObject.push(configNodesMap[nodeId].children[key1].type)
          childrenObject.push(configNodesMap[nodeId].children[key1].name)
          tasksObject[configNodesMap[nodeId].name].push(childrenObject)
        }
      } else if (
        configNodesMap[nodeId].type == 'esproducers' &&
        rootNodeIds[configNodesMap[nodeId].name] == nodeId //main esproducer node
      ) {
        let esProducerObject: Object = { params: {}, ctype: '', pytype: '' }

        //now go through all esproducer children and add them to array
        for (const [key1, value1] of Object.entries(
          configNodesMap[nodeId].children
        )) {
          let paramObject: Object = {}
          paramObject['type'] = configNodesMap[nodeId].children[key1].type
          if (
            paramObject['type'] == 'cms.VPSet' ||
            paramObject['type'] == 'cms.PSet' ||
            paramObject['type'] == 'cms.untracked.PSet' ||
            paramObject['type'] == 'cms.untracked.VPSet'
          ) {
            //parse children here recursivly to elementary parameter objects
            this.parseRecursiveVPSetObject(
              paramObject,
              configNodesMap[nodeId].children[key1].children
            )
            esProducerObject['params'][
              configNodesMap[nodeId].children[key1].name
            ] = paramObject
          } else {
            paramObject['value'] =
              configNodesMap[nodeId].children[key1].paremeterJSONValue

            esProducerObject['params'][
              configNodesMap[nodeId].children[key1].name.substring(
                0,
                configNodesMap[nodeId].children[key1].name.length - 3
              )
            ] = paramObject
          }
        }
        esProducerObject['ctype'] = configNodesMap[nodeId].ctype
        esProducerObject['pytype'] = configNodesMap[nodeId].pytype
        esProducersObject[configNodesMap[nodeId].name] = esProducerObject
      } else if (
        configNodesMap[nodeId].type == 'essources' &&
        rootNodeIds[configNodesMap[nodeId].name] == nodeId //main essource node
      ) {
        let esSourceObject: Object = { params: {}, ctype: '', pytype: '' }

        //now go through all essource children and add them to array
        for (const [key1, value1] of Object.entries(
          configNodesMap[nodeId].children
        )) {
          let paramObject: Object = {}
          paramObject['type'] = configNodesMap[nodeId].children[key1].type
          if (
            paramObject['type'] == 'cms.VPSet' ||
            paramObject['type'] == 'cms.PSet' ||
            paramObject['type'] == 'cms.untracked.PSet' ||
            paramObject['type'] == 'cms.untracked.VPSet'
          ) {
            //parse children here recursivly to elementary parameter objects
            this.parseRecursiveVPSetObject(
              paramObject,
              configNodesMap[nodeId].children[key1].children
            )
            esSourceObject['params'][
              configNodesMap[nodeId].children[key1].name
            ] = paramObject
          } else {
            paramObject['value'] =
              configNodesMap[nodeId].children[key1].paremeterJSONValue

            esSourceObject['params'][
              configNodesMap[nodeId].children[key1].name.substring(
                0,
                configNodesMap[nodeId].children[key1].name.length - 3
              )
            ] = paramObject
          }
        }
        esSourceObject['ctype'] = configNodesMap[nodeId].ctype
        esSourceObject['pytype'] = configNodesMap[nodeId].pytype
        esSourcesObject[configNodesMap[nodeId].name] = esSourceObject
      } else if (
        configNodesMap[nodeId].type == 'services' &&
        rootNodeIds[configNodesMap[nodeId].name] == nodeId //main service node
      ) {
        let serviceObject: Object = { params: {}, ctype: '', pytype: '' }

        //now go through all essource children and add them to array
        for (const [key1, value1] of Object.entries(
          configNodesMap[nodeId].children
        )) {
          let paramObject: Object = {}
          paramObject['type'] = configNodesMap[nodeId].children[key1].type
          if (
            paramObject['type'] == 'cms.VPSet' ||
            paramObject['type'] == 'cms.PSet' ||
            paramObject['type'] == 'cms.untracked.PSet' ||
            paramObject['type'] == 'cms.untracked.VPSet'
          ) {
            //parse children here recursivly to elementary parameter objects
            this.parseRecursiveVPSetObject(
              paramObject,
              configNodesMap[nodeId].children[key1].children
            )
            serviceObject['params'][
              configNodesMap[nodeId].children[key1].name
            ] = paramObject
          } else {
            paramObject['value'] =
              configNodesMap[nodeId].children[key1].paremeterJSONValue

            serviceObject['params'][
              configNodesMap[nodeId].children[key1].name.substring(
                0,
                configNodesMap[nodeId].children[key1].name.length - 3
              )
            ] = paramObject
          }
        }
        serviceObject['ctype'] = configNodesMap[nodeId].ctype
        serviceObject['pytype'] = configNodesMap[nodeId].pytype
        servicesObject[configNodesMap[nodeId].name] = serviceObject
      }
    }

    savedFileContentObject['configuration']['seqs'] = sequencesObject
    savedFileContentObject['configuration']['paths'] = pathsObject
    savedFileContentObject['configuration']['mods'] = modulesObject
    savedFileContentObject['configuration']['psets'] = psetsObject
    savedFileContentObject['configuration']['tasks'] = tasksObject
    savedFileContentObject['configuration']['esprods'] = esProducersObject
    savedFileContentObject['configuration']['essources'] = esSourcesObject
    savedFileContentObject['configuration']['services'] = servicesObject

    /*     console.log(
      'SAVED: ' +
        JSON.stringify(
          savedFileContentObject['configuration']['mods'][
            'siPixelClusters_clone'
          ]
        )
    ) */

    let savedFileContent = JSON.stringify(savedFileContentObject, undefined, 2)
    return savedFileContent
  },
  parseRecursiveVPSetObject(parameterObject: Object, children: Array<Object>) {
    if (children.length == 0) {
      if (
        parameterObject['type'] == 'cms.PSet' ||
        parameterObject['type'] == 'cms.untracked.PSet'
      )
        parameterObject['value'] = [{}]
      else if (
        parameterObject['type'] == 'cms.VPSet' ||
        parameterObject['type'] == 'cms.untracked.VPSet'
      )
        parameterObject['value'] = []
      return
    }
    let vpSetObjectArray: Array<Object> = []

    let vpSetObject: Object = {}
    //console.log('children.length' + children.length)

    for (const [key, childObject] of Object.entries(children)) {
      //console.log('KEY:' + key)
      //console.log('VALUE : ' + JSON.stringify(childObject))
      let vPSetParamObject: Object = {}
      if (childObject['name'] == 'PSet') {
        //no named PSets
        this.parseRecursiveVPSetObject(
          vPSetParamObject,
          childObject['children']
        )
        vpSetObjectArray.push(vPSetParamObject)
      } else {
        vPSetParamObject['type'] = childObject['type']
        if (
          vPSetParamObject['type'] == 'cms.VPSet' ||
          vPSetParamObject['type'] == 'cms.PSet' ||
          vPSetParamObject['type'] == 'cms.untracked.PSet' ||
          vPSetParamObject['type'] == 'cms.untracked.VPSet'
        ) {
          this.parseRecursiveVPSetObject(
            vPSetParamObject,
            childObject['children']
          )
          vpSetObject[childObject['name']] = vPSetParamObject
        } else {
          //basic types
          vPSetParamObject['value'] = childObject['paremeterJSONValue']
          vpSetObject[
            childObject['name'].substring(0, childObject['name'].length - 3)
          ] = vPSetParamObject
        }
      }
    }
    if (parameterObject['type'] != undefined) {
      //if it's not empty PSet push object in array
      if (!Utils.isEmpty(vpSetObject)) vpSetObjectArray.push(vpSetObject)
      parameterObject['value'] = vpSetObjectArray
    } else {
      parameterObject = Object.assign(parameterObject, vpSetObject) //oterwise just assign object
    }
  },
}
